import script from "./HomeworkSubpage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeworkSubpage.vue?vue&type=script&lang=ts&setup=true"

import "./HomeworkSubpage.vue?vue&type=style&index=0&id=86ef266c&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86ef266c"]])

export default __exports__